import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { IdentityActions } from './identity.actions';
import { IIdentityState } from './identity.state';

export const initialIdentityState: IIdentityState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const identityReducerFn = createReducer(
  initialIdentityState,
  on(IdentityActions.reset, (state: IIdentityState, action) => {
    return new StateBuilder<IIdentityState>(initialIdentityState).build();
  }),
  on(IdentityActions.updateModel, (state: IIdentityState, action) => {
    return new StateBuilder<IIdentityState>(state, action).build();
  }),
  on(IdentityActions.submit, (state: IIdentityState, action) => {
    return new StateBuilder<IIdentityState>(state, action).toLoading().build();
  }),
  on(IdentityActions.submitSuccess, (state: IIdentityState, action) => {
    return {
      ...state,
      ...{ model: { ...state.model }, ...{ data: { ...state.data, ...action.data } } }
    };
  }),
  on(IdentityActions.loadSuccess, (state: IIdentityState, action) => {
    return new StateBuilder<IIdentityState>(state, action).toLoaded().build();
  })
);

export function identityReducer(state: IIdentityState | undefined, action: Action) {
  return identityReducerFn(state, action);
}
